import { render, staticRenderFns } from "./TagBase.vue?vue&type=template&id=2ac8e7b5&scoped=true&"
import script from "./TagBase.vue?vue&type=script&lang=js&"
export * from "./TagBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac8e7b5",
  null
  
)

export default component.exports